const CloseMenuButton = ({onClick, className, ...rest}) => {

  return (
    <svg xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 109.04 109.04"
        className={className}
        onClick={onClick}
        {...rest}>
        <g>
          <rect width="109.04" height="109.04" rx="12.59" fill="#384ea1" opacity="0.3" />
          <g>
            <path d="M77.73,55.8a2.55,2.55,0,0,1-2.21,1.28H29.18l6.21,6.21A2.54,2.54,0,0,1,36,65.74a2.55,2.55,0,0,1-4.25,1.16L21.2,56.33a2.52,2.52,0,0,1,0-3.53s.07-.1.06-.1L31.79,42.13a2.56,2.56,0,0,1,1.81-.77,2.66,2.66,0,0,1,1.82.75,2.56,2.56,0,0,1,0,3.64L29.18,52H75.52a2.56,2.56,0,0,1,2.21,3.84Z" fill="#e2e2e2" />
            <rect x="38.65" y="28.02" width="39.46" height="5.21" rx="2.6" fill="#e2e2e2" />
            <rect x="38.65" y="75.82" width="39.46" height="5.21" rx="2.6" fill="#e2e2e2" />
          </g>
        </g>
  </svg>
)};
export default CloseMenuButton;